import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getOnhandInventoryItemsByInventoryId, cleanUpInventoryItems } from '@store/INV/MasterItems/MasterItemsSlice';
import { useTranslation } from 'react-i18next';

const useGetOnhandInventoryItemsByInventoryId = ({
  InventoryId,
  SubInventoryId
}: {
  InventoryId: string;
  SubInventoryId?: string;
}) => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (InventoryId) {
       dispatch(getOnhandInventoryItemsByInventoryId({ InventoryId, SubInventoryId }));
    }
    return () => {
      dispatch(cleanUpInventoryItems());
    };
  }, [InventoryId, SubInventoryId, dispatch]);
  const { InventoryItems, loading, error } = useAppSelector(state => state.MasterItemsINV);

  const InventoryItemsOptions = InventoryItems?.map(item => {
    const StockQty = item.qtyByLot.reduce((sum, item) => sum + (item?.qty || 0), 0) ?? 0; // الكمية المتواجدة في المخزن
    const ReservedQty = item.qtyByLot.reduce((sum, item) => sum + (item?.reservationQty || 0), 0) ?? 0; // الكمية المحجوزة في المخزن
    const AvailableQty = StockQty - ReservedQty; // الكمية المتاحة في المخزن

    return {
      value: item.itemId,
      label: i18n.language === 'en' ? item.name : item.name2,
      //________________________________________________________________
      itemId: item.itemId,
      barcode: item.barcode,
      itemName: `${i18n.language === 'en' ? item.name : item.name2}`,
      itemCode: item.itemCode,
      uom: item.unitOfMeasure,
      uomName: `${i18n.language === 'en' ? item.unitOfMeasureName : item.unitOfMeasureName2}`,
      // QtyAvailable: item.qty,
      isPrimaryUOM: item.isPrimaryUOM,
      categoryId: item.categoryId,
      /// ✅ الكمية حسب اللوت
      lotQtys: item.qtyByLot?.map(m => ({
        lotId: m.lotId,
        lotNumber: m.lotNumber,
        qty: m.qty,
        reservationQty: m.reservationQty,
        expirationDate: m.expirationDate?.toString()?.split('T')[0]
      })),

      /// ✅ الكمية المتاحة حسب اللوت بعد حجزها
      lotAvlQtys: item.qtyByLot?.map(lot => {
        const availableLotQty = (lot.qty || 0) - (lot.reservationQty || 0); // حساب الكمية المتاحة لكل لوت
        return {
          lotId: lot.lotId,
          lotNumber: lot.lotNumber,
          qty: availableLotQty > 0 ? availableLotQty : 0, // منع القيم السالبة
          reservationQty: lot.reservationQty,
          expirationDate: lot.expirationDate?.toString()?.split('T')[0]
        };
      }),

      StockQty, // الكمية المتواجدة في المخزن
      ReservedQty, // الكمية المحجوزة في المخزن
      AvailableQty // الكمية المتاحة في المخزن
    };
  });

  // const SumQtyInStore =
  // InventoryItemsOptions?.find(
  //   f => f.itemId === line.transactionItemId
  // )?.qtyByLot?.reduce((sum, item) => sum + item.qty, 0) ?? 0;

  const uniqueItemsOptions = InventoryItemsOptions?.filter(
    (item, index, self) => index === self.findIndex(i => i.itemId === item.itemId)
  ); // الأصناف تأتي مكررة حسب الـ الوحدات -- وهذه تتجليها مفردة

  return { InventoryItemsOptions, InventoryItems, loading, error, uniqueItemsOptions };
};

export default useGetOnhandInventoryItemsByInventoryId;
